import { createContext, use } from "react";
//#region src/components/menu/menu.panel.context.ts
var MenuPanelContext = createContext(void 0);
var useMenuPanelContext = () => {
	const context = use(MenuPanelContext);
	if (!context) throw new Error("Menu panel parts require a defaultPanel on Menu.Content");
	return context;
};
//#endregion
export { MenuPanelContext, useMenuPanelContext };
